export const FIRST_LOGIN_PARAMETER_NAME = "firstLogin";